export function getVersionRefreshManager() {
  return {
    requestRefresh: () => undefined,
    subscribe: () => () => undefined,
    addBlocker: (_id: string) => undefined,
    removeBlocker: (_id: string) => undefined,
  };
}
